import React from 'react';
import DragAndDrop from '../DragAndDrop/DragAndDrop';
import { getTranslation } from '../../assets/creator/translations';
import { OptionsButton, ArrowUpButton, ArrowDownButton, ArrowLeftButton, ArrowRightButton, DeleteButton } from './Buttons/Buttons';

const showOverlay = (e, isDragging, containerClass) => {
    if (!isDragging) {
        const node = e.target.closest(`.${containerClass}__overlay`);
        if (!node) {
            return;
        }
        node.classList.add(containerClass + "__overlay_active");
    }
};

const hideOverlay = (e, containerClass) => {
    const node = e.target.closest(`.${containerClass}__overlay`);
    if (!node) {
        return;
    }
    node.classList.remove(containerClass + "__overlay_active");
};

const DragIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fill="#4A5DE2" fillRule="evenodd" d="M6 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm0 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm0 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm8-12a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm0 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm0 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0z" />
    </svg>
)

export const CopyList = (props) => {
        
    const overlayButtons = () => 
    <div className="draggable-list__container">
        <div className="draggable-list__container-drag-icon">
            <DragIcon/>
        </div>
    <div className="draggable-list__text">{getTranslation("DragAndDrop")}</div>
    </div>
    

    return <DragAndDrop
        {...props}
        overlayButtons={overlayButtons}
        type='copy'
        containerClass="draggable-list"
        showOverlay={showOverlay}
        hideOverlay={hideOverlay} />;
};

const getHandleDragChange = (props) =>  {
 
    const handleDragStart = (list, isSource) => {
        list.current.classList.add('accept-drop');
        if (isSource) {
            list.current.style.zIndex = '103';
        }
    };
    const handleDragEnd = (list, isSource) =>  {
        list.current.classList.remove('accept-drop', 'accept-drop-border') ;
        if (isSource) {
            list.current.style.zIndex = '';
        }
    };
    

    
    return ((isDragging, list, isSource) => {      
        props.handleDragChange(isDragging);
        if (isDragging) {
            handleDragStart(list, isSource);
        } else {
            handleDragEnd(list, isSource);
        }
    });
}

const checkArrowPosition = (element, arrowPosition, leftPosition, rightPosition, topPosition, bottomPosition) => {
    if(element.type==="widget"){
        const widgetPosition = JSON.parse(element.config).widgetPosition 
        if(widgetPosition.includes(leftPosition)){
            arrowPosition.left = false;
        }
        if(widgetPosition.includes(rightPosition)){
            arrowPosition.right = false;
        }
        if(widgetPosition.includes(topPosition)){
            arrowPosition.top = false;
        }
        if(widgetPosition.includes(bottomPosition)){
            arrowPosition.bottom = false;
        }
    }
};

const deleteInlineStyle = () => { 
    const sortableListItems = document.querySelectorAll('.sortable-list__item');
    sortableListItems.forEach(item => {
        if(item.style.top){
        item.style.removeProperty('top');
        }
    });
};

const onDeleteButtonClick = (isDragging, i, props) => { 
    deleteInlineStyle()
    return (!isDragging() && props.onListChange(props.listName, { removedIndex: i, addedIndex: null, payload: null }));
};

const onArrowUpButtonClick = (element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToUp, i, upIndex) => {
    if(element.type==="widget"){
        changeWidgetPosition(topPosition, props, leftPosition, rightPosition, topPosition, bottomPosition);
    }
    else{
        return (!isDragging() && allowToUp && props.onListChange(props.listName, { removedIndex: i, addedIndex: upIndex, payload: null}));
    }
};

const onArrowDownButtonClick = (element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToDown, i, downIndex) => {
    if(element.type==="widget"){
        changeWidgetPosition(bottomPosition, props, leftPosition, rightPosition, topPosition, bottomPosition);
    }
    else{
        return (!isDragging() && allowToDown && props.onListChange(props.listName, { removedIndex: i, addedIndex: downIndex, payload: null}));
    }
};

const onArrowRightButtonClick = (element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToRight) => {
    if(element.type==="widget"){
        changeWidgetPosition(rightPosition, props, leftPosition, rightPosition, topPosition, bottomPosition);
    }
    else{
        return (!isDragging() && allowToRight)
    }
};

const onArrowLeftButtonClick = (element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToLeft) => {
    if(element.type==="widget"){
        changeWidgetPosition(leftPosition, props, leftPosition, rightPosition, topPosition, bottomPosition);
    }
    else{
        return (!isDragging() && allowToLeft )
    }
};

const onOptionsButtonClick = (props, i, element) => props.handleOptionsOpen({ listName: props.listName, index: i, element });

function changeWidgetConfig(arrayOfObjects, newConfiguration, props) {
    for (let i = 0; i < arrayOfObjects.length; i++) {
      if (arrayOfObjects[i].type === "widget") {
        try {
          // Parse the "config" field into an object
          const currentConfig = JSON.parse(arrayOfObjects[i].config);
          // Modify the configuration
          currentConfig.widgetPosition = newConfiguration;
          // Convert the object back to a string
          arrayOfObjects[i].config = JSON.stringify(currentConfig);
          props.changeConfig(props.listName, i , arrayOfObjects[i].config , true )
        } catch (error) {
          console.error("Error parsing the configuration:", error);
        }
      }
    }
    return arrayOfObjects;
}

const saveSettingsToLocalStorage = (newClassName, props) => {
    const separator = "__"; 
    const lastIndex = newClassName.lastIndexOf(separator);
    const newPosition = newClassName.slice(lastIndex + separator.length);

    const settings = JSON.parse(localStorage.getItem('onlineCreatorB2B-settings'));
    let widgetPosition = JSON.parse(localStorage.getItem('onlineCreatorB2B-widget'));
    widgetPosition=newPosition;
    localStorage.setItem('onlineCreatorB2B-widget', JSON.stringify(widgetPosition));   

    if(settings!==null && settings!==undefined){
        settings.widgetPosition=newPosition;
        localStorage.setItem("onlineCreatorB2B-settings", JSON.stringify(settings));
        const settingsMainBodyWidget = JSON.parse(localStorage.getItem('onlineCreatorB2B-mainBody'));
        const widgetConfigSettings = changeWidgetConfig(settingsMainBodyWidget, newPosition, props)
        localStorage.setItem("onlineCreatorB2B-mainBody", JSON.stringify(widgetConfigSettings));
    }
}

const changeWidgetPosition = (newPosition, props, leftPosition, rightPosition, topPosition, bottomPosition) => {
    const widgetElementRightTop = document.querySelector('.sortable-list__popup__widget1__rightTop');
    const widgetElementLeftTop = document.querySelector('.sortable-list__popup__widget1__leftTop');
    const widgetElementLeftBottom = document.querySelector('.sortable-list__popup__widget1__leftBottom');
    const widgetElementRightBottom = document.querySelector('.sortable-list__popup__widget1__rightBottom');
    
    const widgetElementsArray = [widgetElementRightTop, widgetElementLeftTop, widgetElementLeftBottom, widgetElementRightBottom]

    widgetElementsArray.forEach((widgetElement) => {
        if(widgetElement!==null){
            deleteInlineStyle();
            const oldClassName = widgetElement.classList;
            const classesToRemove = [...oldClassName]
            let newClassName;
            if(newPosition === leftPosition){
                newClassName = oldClassName[1].replace(rightPosition, newPosition)
            }
            else if (newPosition === rightPosition){
                newClassName = oldClassName[1].replace(leftPosition, newPosition)
            }
            else if (newPosition === topPosition){
                newClassName = oldClassName[1].replace(bottomPosition, newPosition)
            }
            else if (newPosition === bottomPosition){
                newClassName = oldClassName[1].replace(topPosition, newPosition)
            }
            else {
                console.warn('Unexpected widget position:', newPosition);
                return;
            }
        
            widgetElement.classList.remove(...classesToRemove);
            widgetElement.classList.add('sortable-list__item', newClassName);
        
            saveSettingsToLocalStorage(newClassName, props)
        }
    });
}

const getOverlayButtonsForElementInSortableList = (props) => (isDragging, i) => {   
    const element = props.getElement(props.listName, i);
    let downIndex = i+1;
    let upIndex = i-1;
    let allowToDown = true;
    let allowToUp = true;
    const allowToLeft = true;
    const allowToRight = true;
    const len = props.items.length-1;
    const leftPosition = 'left';
    const rightPosition = 'right';
    const topPosition = 'Top';
    const bottomPosition = 'Bottom';
    const arrowPosition = { 
      top: true,
      right: true,
      bottom: true,
      left: true,
    } 
    checkArrowPosition(element, arrowPosition, leftPosition, rightPosition, topPosition, bottomPosition);

    // mainBody - arrow up
    if (props.listName === "mainBody" && i !== 0) {
        if (props.items[i-1].id === 'newsletter-3' || props.items[i-1].type === 'popupBanner' || props.items[i-1].id === 'widget-1' || props.items[i-1].id === 'widget-2') {
            if (i === 1) {
                allowToUp = false;
            } else {
                allowToUp = true;
                upIndex = i-2; 
            }
        }
        else {
            allowToUp = true;
            upIndex = i-1;
        }
    } else if (props.listName !== "mainBody" && element.allowToMove !== false && i !== 0 && props.items[i-1].allowToMove !== false) {
        allowToUp = true;
        upIndex = i-1;
    } else {
        allowToUp = false;
    }

    // mainBody - arrow down
    if (props.listName === "mainBody" && i !== len) {
        if (props.items[i+1].id === 'newsletter-3' || props.items[i+1].id === 'widget-1'|| props.items[i+1].id === 'widget-2') {
            if (i === len-1) {
                allowToDown = false;
            } else {
                allowToDown = true;
                downIndex = i+2; 
            }
        }
        else {
            allowToDown = true;
            downIndex = i+1;
        }
    } else if (props.listName !== "mainBody" && element.allowToMove !== false && i !== len && props.items[i+1].allowToMove !== false) {
        allowToDown = true;
        downIndex = i+1;
    } else {
        allowToDown = false;
    }
    
    if (!props.isMobileOn && !props.isPreviewOn) {
        return (
            <React.Fragment>
                <div className="sortable-list__OverlayContainer" >
                    <OptionsButton show={!!element.config && !!element.showOptions}  onClick={() => onOptionsButtonClick(props, i, element)}/>
                    {/* <ArrowUpButton show={allowToUp && element.showArrow} onClick={() => onArrowUpButtonClick(element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToUp, i, upIndex)} />
                    <ArrowDownButton show={allowToDown && element.showArrow} onClick={() => onArrowDownButtonClick(element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToDown, i, downIndex)} /> */}
                    <ArrowLeftButton show={ (allowToLeft && element.showAllArrows)} onClick={() => onArrowLeftButtonClick(element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToLeft)} widgetShow={ element.showAllArrows} widgetArrowShow={ arrowPosition.left } />
                    <ArrowUpButton show={ (allowToUp && element.showArrow) } onClick={() => onArrowUpButtonClick(element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToUp, i, upIndex)} widgetShow={ element.showAllArrows } widgetArrowShow={ arrowPosition.top } />
                    <ArrowDownButton show={ (allowToDown && element.showArrow) } onClick={() => onArrowDownButtonClick(element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToDown, i, downIndex)}  widgetShow={ element.showAllArrows } widgetArrowShow={ arrowPosition.bottom }/>
                    <ArrowRightButton show={ allowToRight && element.showAllArrows } onClick={() => onArrowRightButtonClick(element, props, leftPosition, rightPosition, topPosition, bottomPosition, isDragging, allowToRight)} widgetShow={ element.showAllArrows } widgetArrowShow={ arrowPosition.right } />
                    <DeleteButton onClick={() => onDeleteButtonClick(isDragging, i, props)} />
                </div>
            </React.Fragment>
        );
    }
};


//contains section content, be it a header, a footer or a body (content)
export const SortableList = (props) => {

    const handleDragEnter = list => list.current.classList.add( 'accept-drop-border');
    const handleDragLeave = list => list.current.classList.remove('accept-drop-border');

    const handleDragChange = getHandleDragChange(props);

    const overlayButtons = getOverlayButtonsForElementInSortableList(props);

    return <DragAndDrop
        {...props}
        overlayButtons={overlayButtons}
        handleDragChange={handleDragChange}
        handleDragEnter={handleDragEnter}
        handleDragLeave={handleDragLeave}
        containerClass="sortable-list"
        showOverlay={showOverlay}
        hideOverlay={hideOverlay} />;
};

